import { useNavigate } from "react-router-dom";
import { useAccountHistory } from "@dealer-center/ddc-api-account-fetch";

export const useNavigateToAccount = () => {
  const { addToAccountHistory } = useAccountHistory();
  const navigate = useNavigate();

  return {
    navigateToAccount: (accountId: string) => {
      if (!accountId) {
        return;
      }
      addToAccountHistory(accountId);
      navigate("/dealer/" + accountId);
    }
  };
};
